// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"489":"61bf55ac318b34e9e9e7","793":"ea821ee43878085ef69c","845":"4923e3d53cf46f9d5136"}[chunkId] + ".bundle.js";
};